import SideBar from "./SideBar";
import BookingArea from "./BookingArea";
import { useHotelContext } from "hooks/hotel/useHotelContext";
import { Navigate } from "react-router-dom";
import { useEffect } from "react";
const HotelBookingArea = () => {
    const { hotelSelection } = useHotelContext();
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);
    if (!hotelSelection?.selectedHotel) {
        return <Navigate to={"/hotel-search"} />;
    }

    return (
        <>
            <section id="tour_booking_submission" className="section_padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <BookingArea />
                        </div>
                        <div className="col-lg-4">
                            <SideBar />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default HotelBookingArea;
